<template>
  <div class="donga-audit">
    <admin-header></admin-header>
    <div class="audit-template admin-template">
      <admin-aside></admin-aside>
      <div class="admin-container">
        <h2 class="contents-tit">제보된 글</h2>
        <div class="state-search">
          <div class="state-num">
            <span class="state-all state" style="color:#000">모두<span class="num">({{this.getReportWrtingListLength}})</span></span>
            <span class="state-reception state" style="color:#ff8b2e">접수대기
              <span class="num" v-if="this.getStatusCountMap.접수대기 !== undefined">({{this.getStatusCountMap.접수대기}})</span>
              <span class="num" v-else>(0)</span>
            </span>
            <span class="state-progress state" style="color:#029c40">접수
              <span class="num" v-if="this.getStatusCountMap.접수 !== undefined">({{this.getStatusCountMap.접수}})</span>
              <span class="num" v-else>(0)</span>
            </span>
            <span class="state-reception state" style="color:#ff2d2d">진행
              <span class="num" v-if="this.getStatusCountMap.진행 !== undefined">({{this.getStatusCountMap.진행}})</span>
              <span class="num" v-else>(0)</span>
            </span>
            <span class="state-progress state" style="color:#4174ff">완료
              <span class="num" v-if="this.getStatusCountMap.완료 !== undefined">({{this.getStatusCountMap.완료}})</span>
              <span class="num" v-else>(0)</span>
            </span>
          </div>
        </div>
        <div class="input-excel">
          <div class="input-area">
            <div class="card-input">
              <select v-model.trim="companyType" class="default-select">
                <option value="">전체 회사</option>
                <option v-for="(company) in this.getAdminCompanyTypeMaps" v-bind:key="company.code" v-bind:value="company.code">
                  {{ company.title }}
                </option>
              </select>
            </div>
            <div class="card-input right">
              <select v-model.trim="postSort" class="default-select">
                <option value="createdDate,desc">최신순</option>
                <option value="commentCreatedDate,desc">댓글 최신순</option>
              </select>
              <button type="button" class="admin-default-btn" @click="PageFilter()">검색</button>
            </div>
          </div>
          <div class="excel-area">
            <button type="button" class="excel-btn" @click="downExcel()">Excel</button>
          </div>
        </div>
        <section class="admin-contents">
          <div class="card-body">
            <table class="card-table">
              <caption>제보된 글</caption>
              <colgroup>
                <col style="width:10%">
                <col style="width:15%">
                <col style="width:15%">
                <col style="width:10%">
                <col style="width:10%">
                <col style="width:auto">
              </colgroup>
              <tr>
                <th>no</th>
                <th>제보 회사</th>
                <th>제보 날짜</th>
                <th>상태</th>
                <th>유형</th>
                <th>제보 제목</th>
              </tr>
              <tr v-for="(item, index) in this.adminWrtingList.content" :key="index" @click="adminInquiry(item.id)">
                <td colspan="row">{{item.id}}</td>
                <td>{{item.companyType}}</td>
                <td>{{item.createdDate}}</td>
                <td>
                  <span v-if ="item.status === '접수대기'" style="color:#ff8b2e">
                    {{item.status}}
                  </span>
                  <span v-else-if ="item.status === '접수'" style="color:#029c40">
                    {{item.status}}
                  </span>
                  <span v-else-if ="item.status === '진행'" style="color:#ff2d2d">
                    {{item.status}}
                  </span>
                  <span v-else style="color:#4174ff">
                    {{item.status}}
                  </span>
                </td>
                <td>{{displayReportType(item)}}</td>
                <td><span class="elp ellipsis">{{item.title}} ({{item.commentCount}})</span></td>
              </tr>
            </table>
          </div>
          <div class="card-footer">
            <paginate v-model="currentPage"
            :page-count="getPageTotal"
            :page-range="5"
            :margin-pages="1"
            :click-handler="clickCallback"
            :prev-text="'이전'"
            :next-text="'다음'"
            :container-class="'pagination'"
            :page-class="'page-item'">
            </paginate>
          </div>
        </section>
      </div>
    </div>
    <admin-footer></admin-footer>
  </div>
</template>

<style lang="scss" scoped>
@import '../css/sub.scss';
@import '../css/admin.scss';
</style>

<style lang="css">
@import '../css/bootstrap.min.css';
</style>
<script>
import AdminHeader from '@/components/AdminHeader'
import AdminFooter from '@/components/AdminFooter'
import AdminAside from '@/components/AdminAside'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'AdminReport',
  components: {
    'admin-footer': AdminFooter,
    'admin-header': AdminHeader,
    'admin-aside': AdminAside
  },
  data () {
    return {
      pageOfItems: [],
      companyType: '',
      postSort: 'createdDate,desc',
      currentPage: 1,
      pageId: ''
    }
  },
  created () {
    this.setInit()
    this.setCompanyType()
  },
  methods: {
    ...mapActions({
      setInit: 'apiReportedWriting',
      setCompanyType: 'apiAdminCompanyTypeMaps'
    }),
    adminInquiry (pageId) {
      sessionStorage.setItem('pageId', pageId)
      this.$router.push('/admininquirypage')
    },
    clickCallback (pageNum) {
      const params = {
        'companyType': this.companyType,
        'page': pageNum - 1,
        'postSort': this.postSort
      }
      this.$store.dispatch('apiReportedWriting', params)
    },
    PageFilter () {
      const params = {
        'companyType': this.companyType,
        'page': 0,
        'postSort': this.postSort
      }
      this.$store.dispatch('apiReportedWriting', params)
    },
    downExcel () {
      const params = {
        'companyType': this.companyType,
        'sort': this.postSort
      }
      this.$store.dispatch('apiAdminPostsExcel', params)
    },
    displayReportType (item) {
      const CUTOFF = '2026.10.13'
      const SHORT_LABELS = {
        '임직원 부정(횡령,뇌물,금전거래 등)': '부정비리',
        '근무기강 해이(성희롱,괴롭힘,폭행 등)': '근무기강',
        '협력회사 선정 및 관계의 불합리성(갑질 등)': '공정거래',
        '기타사항': '기타'
      }
      const date = (item.createdDate || '').slice(0, 10)
      if (date >= CUTOFF && SHORT_LABELS[item.reportType]) {
        return SHORT_LABELS[item.reportType]
      }
      return item.reportType
    }
  },
  computed: {
    ...mapGetters([
      'getReportWrtingListLength',
      'getAdminCompanyTypeMaps',
      'getPageTotal',
      'getStatusCountMap'
    ]),
    ...mapGetters({
      adminWrtingList: 'getReportWrtingList'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/AdminReport.vue